import {
  APIErrorResponse,
  isAPIErrorResponse
} from '@arc-publishing/sdk-subs-core/lib/utils/APIErrorResponse';
import JSONResponseHandler from '@arc-publishing/sdk-subs-core/lib/utils/JSONResponseHandler';

import { getValidURL } from './utils';
import AMP from './amp';
import { headers } from './constants';

/**
 * @param ampReaderId
 *
 * @returns __Promise__ Pass an AMP reader ID to update lastLogout date for the ID in AMP context
 * <details>
 *  <summary>
 *    On success (resolves)
 *  </summary>
 *
 * </details>
 *
 * <details>
 *  <summary>
 *    On error (throws)
 *  </summary>
 *
 * ```
 *  See documentation for corresponding error codes:
 *  https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-sales.json#SwG_Interaction/logoutAmpReaderId
 * ```
 * </details>
 */

export interface AMPReaderIdResponse {
  linkedArcIdentity: boolean;
  lastLogin: string;
  lastLogout: string;
}

export default function logoutAMPReaderID(
  ampReaderId: string
): Promise<APIErrorResponse | AMPReaderIdResponse> {
  const url = typeof window !== 'undefined' ? getValidURL(AMP.apiOrigin) : AMP.apiOrigin;

  return fetch(`${url}/sales/public/v1/amp/logout`, {
    method: 'PUT',
    headers: {
      ...headers
    },
    body: JSON.stringify({
      ampReaderId
    })
  })
    .then(JSONResponseHandler)
    .then((json: APIErrorResponse | AMPReaderIdResponse) => {
      if (isAPIErrorResponse(json)) {
        throw json;
      } else {
        return json;
      }
    });
}
